interface ProductVideo {
    previewSrc?: string;
    animatedPreviewSrc?: string;
    walkthroughSrc?: string;
    posterSrc?: string;
    captionsSrc?: string;
}

// Product previews show a static poster until hover/focus, then the short GIF.
// Full 16:9 films play on demand in the modal; construction-specific clips remain pending.
export const PRODUCT_VIDEOS: Record<string, ProductVideo> = {
    build: {
        animatedPreviewSrc: '/media/build/thumbnail.gif',
        walkthroughSrc: '/media/build/promo.mp4',
        posterSrc: '/media/build/poster.jpg',
    },
    live: {
        animatedPreviewSrc: '/media/live/thumbnail.gif',
        walkthroughSrc: '/media/live/promo.mp4',
        posterSrc: '/media/live/poster.jpg',
    },
    report: {
        animatedPreviewSrc: '/media/report/thumbnail.gif',
        walkthroughSrc: '/media/report/promo.mp4',
        posterSrc: '/media/report/poster.jpg',
    },
    'construction-build': {},
    'construction-live': {},
    'construction-report': {},
}
